export const MainStyle = ({ MainAppContainer }) => ({
  content: {
    backgroundColor: `${MainAppContainer.backgroundColor}`,
    minWidth: "100%",
    minHeight: "100%",
  },
});
